import axios from "../api/axiosClient";

export function getCompanies(successCallback, errorCallback) {
  axios
    .get("/masterdata/Companies")
    .then((response) => {
      return response.data;
    })
    .then((data) => {
      successCallback(data);
    })
    .catch((error) => {
      errorCallback(error);
    });
}

export function getDepartments(successCallback, errorCallback) {
  axios
    .get("/masterdata/Departments")
    .then((response) => {
      return response.data;
    })
    .then((data) => {
      successCallback(data);
    })
    .catch((error) => {
      errorCallback(error);
    });
}

export function getCountries(successCallback, errorCallback) {
  axios
    .get("/masterdata/Countries")
    .then((response) => {
      return response.data;
    })
    .then((data) => {
      successCallback(data);
    })
    .catch((error) => {
      errorCallback(error);
    });
}

export function acceptReturnFile(
  idReturnFileHead,
  model,
  successCallback,
  errorCallback
) {
  var url = `/creditnotereturnfiles/${idReturnFileHead}/accept`;
  axios
    .post(url, model)
    .then((response) => {
      return response.data;
    })
    .then((data) => {
      successCallback(data);
    })
    .catch((error) => {
      errorCallback(error);
    });
}

export function finalizeBasket(idBasket, data, successCallback, errorCallback) {
  var url = `s2s/basketmaintenance/${idBasket}/baskets`;
  axios
    .post(url, data)
    .then((response) => {
      return response.data;
    })
    .then((data) => {
      successCallback(data);
    })
    .catch((error) => {
      errorCallback(error);
    });
}

export function getOutcomes(successCallback, errorCallback) {
  axios
    .get("/masterdata/outcomes")
    .then((response) => {
      return response.data;
    })
    .then((data) => {
      successCallback(data);
    })
    .catch((error) => {
      errorCallback(error);
    });
}
